import { Link } from '@inertiajs/react';
import type { InertiaLinkProps } from '@inertiajs/react';
import { cn } from '@/lib/utils';

export type PatientTabKey = 'dashboard' | 'profile' | 'chats' | 'journals' | 'clinical_notes';

type PatientTabsProps = {
  patientId: number;
  active: PatientTabKey;
  className?: string;
  extra?: InertiaLinkProps['children'];
};

const items = (patientId: number) =>
  [
    { key: 'dashboard', label: 'Dashboard', href: `/therapists/patients/${patientId}` },
    { key: 'chats', label: 'Chat', href: `/therapists/patients/${patientId}/chats` },
    { key: 'journals', label: 'Diari', href: `/therapists/patients/${patientId}/journals` },
    {
      key: 'clinical_notes',
      label: 'Note cliniche',
      href: `/therapists/patients/${patientId}/clinical_notes`,
    },
    { key: 'profile', label: 'Profilo', href: `/therapists/patients/${patientId}/profile` },
  ] as const;

export function PatientTabs({ patientId, active, className, extra }: PatientTabsProps) {
  return (
    <div className={cn('flex flex-wrap gap-2 text-sm', className)}>
      {items(patientId).map(({ key, label, href }) => (
        <Link
          key={key}
          href={href}
          className={cn(
            'rounded-full px-3 py-1 text-sm border',
            active === key
              ? 'border-primary bg-primary/10 text-foreground'
              : 'border-border/70 text-muted-foreground hover:text-foreground',
          )}
        >
          {label}
        </Link>
      ))}
      {extra}
    </div>
  );
}
